import SEO from "../components/SEO";
//components
import BannerContact from "../components/BannerContact";
import ContactForm from "../components/ContactForm";
function Values() {

  return (
      <div className="contacts">
        <SEO
          title="Contattaci | Studio Legale Bevilacqua a Pordenone"
          description="Contatta lo Studio Legale Bevilacqua a Pordenone per una consulenza legale. Siamo in Piazzale Ellero dei Mille 6. Tel. +39 0434 208295 – segreteria@slbf.it."
          canonical="/contatti"
        />
        <BannerContact 
          title="Contatti"
        />
        <div className="form-container">
          <ContactForm
            title="Contattaci"
          />
        </div>
      </div>
  );
}

export default Values;